import React, { Dispatch, useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { fetchPermissionDetails } from '../../../actions/memberPortal/enrollmentsActionCreators';
import SideNavContainer from '../../../components/common/nav/SideNavContainer';
import { configs } from '../../../constants/configs/configs';
import withModalWrapper from '../../../containers/common/WithModalWrapper';
import { useAppDispatch } from '../../../hooks';
import { PAGE_TYPE } from '../utils';
import EnrollmentHistory from './EnrollmentListing/EnrollmentHistory';
import EnrollmentPremiumContainer from './EnrollmentPremium/EnrollmentPremiumContainer';
import { modalConfig } from './modals/modalConfig';

const StyledContainer = styled.div`
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    background-color: ${({ theme }) => theme.white};
    box-sizing: border-box;
    border-radius: 1rem;
    margin-bottom: 3rem;
    transition: 0.1s;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    overflow: visible !important;
`;

function EnrollmentContainer() {
    const {
        routes: { MEMBER_ENROLLMENT_LIST, MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY, MEMBER_ENROLLMENT_PREMIUM_HISTORY },
    } = configs;


    return (
        <SideNavContainer page={PAGE_TYPE.ENROLLMENTS}>
            <StyledContainer className="desktop:grid-col-9 enrollment-history-container">
                <Switch>
                    <Route path={MEMBER_ENROLLMENT_LIST} exact component={EnrollmentHistory}></Route>
                    <Route
                        path={MEMBER_ENROLLMENT_PREMIUM_HISTORY}
                        exact
                        component={EnrollmentPremiumContainer}
                    ></Route>
                    <Route
                        path={MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY}
                        exact
                        component={EnrollmentPremiumContainer}
                    ></Route>
                </Switch>
            </StyledContainer>
        </SideNavContainer>
    );
}

export default withModalWrapper(EnrollmentContainer, modalConfig);
